import React, { useState, useEffect } from "react";
import BlogsViewPage from './BlogsViewPage';
import BlogsEditPage from './BlogsEditPage';
import Swal from "sweetalert2";
import axios from "axios";
import { SERVERURL } from "../../../ServerUrl";

const ProjectsTable = (props) => {
  const [filtered2, setFiltered2] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRow2, setSelectedRow2] = useState(null);
  const [alertIndex, setAlertIndex] = useState();
  const deleteClicked = async (index, id, row) => {
    console.log(index, id); //mongoid, array index
    console.log(row); //that particular object
    Swal.fire({
      title: '',
      text: 'Are you sure to Delete ' + row.title + '?',
      icon: 'warning', // Change 'alert' to 'info' for the icon
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then(async (result) => { // Add 'async' before (result)
      if (result.isConfirmed) {
        try {
          const formdata = new FormData();
          formdata.append('id', index); // Append 'id' instead of 'index'

          const token = localStorage.getItem('token'); 
          const headers = {
            'Authorization': `Bearer ${token}`, // Corrected header format
          };

          const response = await axios.post(`${SERVERURL}/api/v1/deleteBlog`, formdata, {
            headers: headers, // Include the headers object in the request configuration
          });
          if (response.data.success === true) {
            // Update the state or perform any action on successful verification
            Swal.fire(
              '',
              'Deleted Successfully!',
              'success'
            );

            let zz = filtered2.filter((item) => item.title !== row.title);
            setFiltered2(zz);
          }
          else
          {
            Swal.fire(
              '',
              response.data.message,
              'error'
            );
          }
        } catch (error) {
            Swal.fire({
              title: "",
              text: "An Error Occured.",
              icon: 'error'
            })
          }
        }
      });
    setAlertIndex(id); // Setting alert index
  };

  const updateFilteredData = () => {
    if (props.driverData) { 
      setFiltered2(props.driverData);
    }
  };
  useEffect(() => {
    updateFilteredData();
  }, [props.driverData]);  

  const handleViewClick = (index) => {
    setSelectedRow(filtered2[index]);
  };
  const handleEditClick = (index) => {
    setSelectedRow2(filtered2[index]);
  };
  const handleCloseDialog = () => {
    setSelectedRow(null);
  };
  const handleCloseEditDialog = () => {
    setSelectedRow2(null);
  };

  return (
    <div className="admin-table-wrap">
      <table className="admin-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Written By</th>
            <th>Read Time</th>
            <th>Type</th>
            <th>Posted</th>
            <th>Actions</th>
          </tr>
        </thead>
{
filtered2 && (
  <tbody>
  {filtered2.map((item, index) => (
    <tr key={index}>
      <td className="admin-table-strong">{item.title}</td>
      <td><div className="pictureee">
    <img
      src={SERVERURL + '/uploads/' + item.user.image}
      alt="AuthorPic"
      className="w-10 h-10 rounded-full"
    />
  </div></td>
      <td>{item.readTime}</td>
      <td>{item.type}</td>
      <td>{item.createdAt}</td>
      <td className="admin-actions-cell">
        <button className="admin-action admin-action-view" onClick={() => handleViewClick(index)}>
          View
        </button>
        <button className="admin-action admin-action-edit" onClick={() => handleEditClick(index)}>
          Edit
        </button>
        <button className="admin-action admin-action-delete" onClick={() => deleteClicked(item._id, index, item)}>
          Delete
        </button>
      </td>
    </tr>
  ))}
</tbody>


)
 

}
      </table>
    
      {selectedRow && (
      <BlogsViewPage 
      selectedRow={selectedRow} 
      onCloseDialog={handleCloseDialog} 
    />
      )}

{selectedRow2 && (
      <BlogsEditPage 
      selectedRow={selectedRow2} 
      onCloseDialog={handleCloseEditDialog}
    
    />
      )}

    
    
        </div>
  );
};

export default ProjectsTable;
